import { useMsal } from "@azure/msal-react";
import { Grid, Stack, Typography } from "@mui/material";
import axios from "axios";
import mailData from ".././../data/mailData";

import React, { useEffect, useState } from "react";
import Floaticons from "../Floaticons";
import ManualTestingLearningCards from "./MTLearningCards";
import ManualTestingLearningJourney from "./MTLearningJourney";
import "./ManualTesting.css";
import "./SREContent.css";

import useFetchImageUrls from "../../ConstantUseFetchImageUrls";
import { manualtestPageImages } from "../../imagesData/ImagesData";

function ManualTestingMain() {
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [isUserPresent, setuserPresent] = useState(true);

  //const baseURL = "http://localhost:3004";
  const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
  let program = "Manual Testing";
  const activeAccount = instance.getActiveAccount();
  //  const checkUserPresent = (name) => {
  //   axios
  //    .get(`${baseURL}/checkNominationList/${name}/${program}`, {
  //     headers: {
  //      "Cache-Control": "no-cache",
  //      Accept: "application/json",
  //      Pragma: "no-cache",
  //      Expires: "0",
  //     },
  //    })
  //    .then((res) => {
  //     console.log("Reponse is", res.data);
  //     let users = res.data;
  //     axios
  //      .get(`${baseURL}/checkAdminList/${name}`, {
  //       headers: {
  //        "Cache-Control": "no-cache",
  //        Accept: "application/json",
  //        Pragma: "no-cache",
  //        Expires: "0",
  //       },
  //      })
  //      .then((res) => {
  //       console.log("Reponse is", res.data);

  //       users.length != 0 || res.data.length != 0
  //        ? setuserPresent(true)
  //        : setuserPresent(false);
  //      })
  //      .catch((err) => {
  //       console.log(err);
  //      });
  //    })
  //    .catch((err) => {
  //     console.log(err);
  //    });
  //  };
  const checkUserPresent = (name) => {
    axios
      .get(`${baseURL}/checkUserActive/${name}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let activeUser = res.data;
        console.log("Res.data first", res.data);
        if (activeUser.length != 0) {
          axios
            .get(`${baseURL}/checkNominationList/${name}/${program}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              let users = res.data;
              console.log("Res.data seconf", res.data);

              users.length != 0 ? setuserPresent(true) : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          axios
            .get(`${baseURL}/checkAdminList/${name}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log("Reponse is", res.data);

              res.data.length != 0
                ? setuserPresent(true)
                : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);

      checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount.idTokenClaims.enterpriseID]);

  const query = `params=${encodeURIComponent(
    JSON.stringify(manualtestPageImages)
  )}`;
  const { imageUrls, error } = useFetchImageUrls(query);
  if (error) return <div>Error loading images.</div>;
  return (
    <>
      <div id="manualTesting">
        <div className="main-banner">
          <img
            src={imageUrls?.imageUrl?.img1}
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on ABC
                University Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        {isUserPresent ? (
          <div className="main-container">
            {/* section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <h2>About Manual Testing</h2>
                <p>
                  Manual software testing is when human testers check the
                  quality of a new application without using automation tools or
                  scripting. The purpose is to identify bugs or defects, ensure
                  the product is error-free, and check it conforms to specified
                  functional requirements.
                </p>
              </div>
            </div>
            {/* section 2  */}
            <div className="program-container">
              <div className="program-wrap">
                <h2>Program Objectives</h2>
                <Grid container sx={{ marginBottom: "1rem" }}>
                  <Grid item xs={12}>
                    <Stack spacing={1}>
                      <Stack
                        direction={"row"}
                        spacing={1}
                        alignItems={"center"}
                      >
                        <img
                          style={{ width: "16px", height: "16px" }}
                          src="images/bulletWhite.png"
                        ></img>
                        <Typography>
                          These trainings will enable you to identify bugs as
                          early as possible so that the software is bug-free.{" "}
                        </Typography>
                      </Stack>

                      <Stack
                        direction={"row"}
                        spacing={1}
                        alignItems={"center"}
                      >
                        <img
                          style={{ width: "16px", height: "16px" }}
                          src="images/bulletWhite.png"
                        ></img>
                        <Typography>
                          {" "}
                          Equip learners with the SDLC , Software testing
                          methodologies, Test case design , analysis and
                          execution knowledge.
                        </Typography>
                      </Stack>
                      <Stack
                        direction={"row"}
                        spacing={1}
                        alignItems={"center"}
                      >
                        <img
                          style={{ width: "16px", height: "16px" }}
                          src="images/bulletWhite.png"
                        ></img>
                        <Typography>
                          Enable  learners with the test management and test
                          automation concepts.
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>

                {/* <ul>
         <li>
          These trainings will enable you to identify bugs as early as possible so that
          the software is bug-free.{" "}
         </li>
         <li>
          Equip learners with the SDLC , Software testing methodologies, Test case design
          , analysis and execution knowledge.
         </li>
         <li>Enable  learners with the test management and test automation concepts. </li>
        </ul> */}
                {/* <div className="program-robot">
                            <img src="images/SRE/SRE-robot.png" alt="SRE-machine" className='SRE-robot' />
                        </div> */}
              </div>
            </div>
            {/* section 3  */}
            <ManualTestingLearningJourney />
            <div className="casestudyNote">
              <p>
                <strong>Note: </strong>For Case Study details, please contact{" "}
                <a href={`mailto:${mailData.LKM_ABCUniversity_mail}`}>
                  {mailData.LKM_ABCUniversity_mail}
                </a>
              </p>{" "}
            </div>
            {/* section 4  */}
            {/* <div className="external-certification-container">
       <h5>External Certifications</h5>
       <p>
        Complete your learning journey and earn accredited external certification in the
        area of your expertise which can help in advancing your career.
       </p>
       <div className="ex-wrapper">
        <div className="ex-box">
         <img src="images/PowerBi/certifications/1.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
        <div className="ex-box">
         <img src="images/PowerBi/certifications/2.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
        <div className="ex-box">
         <img src="images/PowerBi/certifications/4.png" alt="certification-icon" />
         <span>Microsoft Certified:</span>
        </div>
       </div>
      </div> */}
            {/* section 5  */}
            <ManualTestingLearningCards />

            {/* section 6  */}
            <div className="features-container SRE">
              <h5>Program Highlights</h5>
              <div className="features-wrap">
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon1.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Self-paced Learning</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon2.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>SME Connects</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon3.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Final Assessment</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon4.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Earn Completion Certificates, Flair, R&R</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon6.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>End-to-End case studies</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="alter-conatiner">
            <p>
              You are not enrolled to this learning program. Please contact
              &nbsp;
              <a
                onClick={() => {
                  window.open(`mailto:${mailData.LKM_ABCUniversity_mail}`);
                }}
                href=""
              >
                {mailData.LKM_ABCUniversity_mail}
              </a>
              &nbsp; for any queries regarding the program.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default ManualTestingMain;
